<template>
  <selfcheck-loading-modal :visible="modalShow" />
</template>

<script>
import { mapGetters } from 'vuex'
import SelfcheckLoadingModal from '@/components/modal/SelfcheckLoadingModal'

export default {
  components: {
    SelfcheckLoadingModal,
  },
  computed: {
    ...mapGetters({
      modalShow: 'selfcheck/getIsFetching',
    }),
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .modal {
    top: 0px;
  }
  .modal-dialog {
    margin: 0 !important;
    height: 100%;
    max-width: 100%;
  }
  .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-body {
    height: 100%;
    padding: 0 !important;
  }
}
.modal-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: #fff;
  padding-top: 20px;
}
.text {
  padding-top: 20px;
}
</style>
